export enum StoreError {
	ITEM_NOT_ON_SALE = 'Item is not on sale',
	SOLD_OUT = 'Item has reached max supply',
	PENDING_PURCHASE_EXISTS = 'You already have a pending purchase for this item.',
}
